// Pure write-state logic for the Integrations tab. Kept in its own module so
// it can be unit-tested without a React test renderer / DOM.

export const WRITE_CAPABLE_SLUGS = new Set([
  "meta_ads", "instagram", "facebook",
  "brevo",     // DRAFT campaign creation only
  "wordpress", // SEO fields only — representational edits
]);

const BREVO_LABEL = "Borradores con aprobación";
const WP_SEO_LABEL = "SEO con aprobación";

/**
 * Decide the per-channel action button label.
 * @param {string} slug           adapter slug
 * @param {boolean} writesEnabled runtime flag from /chat/status
 * @param {Object}  caps          optional capability map keyed by slug.
 *                                 Example: { wordpress: { executor_available: true } }
 * @returns {{label: string, variant: "approval"|"brevo_draft"|"wp_seo"|"read_only"|"blocked"}}
 */
export function channelActionLabel(slug, writesEnabled, caps) {
  caps = caps || {};
  if (writesEnabled && slug === "brevo") {
    return { label: BREVO_LABEL, variant: "brevo_draft" };
  }
  if (writesEnabled && slug === "wordpress") {
    // Only expose "SEO con aprobación" when the executor has validated the stack
    if ((caps.wordpress || {}).executor_available) {
      return { label: WP_SEO_LABEL, variant: "wp_seo" };
    }
    return { label: "Sólo lectura", variant: "read_only" };
  }
  if (writesEnabled && WRITE_CAPABLE_SLUGS.has(slug)) {
    return { label: "Acciones con aprobación", variant: "approval" };
  }
  if (writesEnabled) {
    return { label: "Sólo lectura", variant: "read_only" };
  }
  return { label: "Escrituras bloqueadas", variant: "blocked" };
}

/**
 * Decide the banner at the top of the Integrations tab.
 * @param {boolean} writesEnabled
 * @returns {{kind: "enabled"|"disabled", heading: string}}
 */
export function integrationsBanner(writesEnabled) {
  return writesEnabled
    ? { kind: "enabled",  heading: "Capacidad operativa activada." }
    : { kind: "disabled", heading: "Modo lectura obligatorio." };
}
